import RequestApi from "../../modules/requestApi";

const state = {
  newsList: []
};

const mutations = {
  SET_NEWS_LIST(state, val) {
    state.newsList = val;
  }
};

const actions = {
  newsListLoad({ commit }) {
    return new Promise((resolve, reject) => {
      RequestApi.newsList()
        .then(data => {
          commit("SET_NEWS_LIST", data);
          resolve(data);
        })
        .catch(reject);
    });
  }
};

const getters = {
  newsList: state => {
    return state.newsList;
  }
};

export default {
  state,
  mutations,
  getters,
  actions
};
